import React, { useContext, useEffect, useMemo, useState, useRef } from "react";

import {
    Avatar,
    Box,
    Button,
    Card,
    Paper,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    TextField,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Chip,
    FormControl,
    Select,
    OutlinedInput,
    Autocomplete,
    Checkbox
} from "@mui/material";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom'
//import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { apiGet } from "app/Services/ApiService";
import { contractorApiUrls } from "common/ApiUrls";
import { Utils } from 'common/Utils';
import {
    Chart as ChartJS, ArcElement, Tooltip, Legend,
    CategoryScale,
    LinearScale,
    BarElement,
    Title
} from 'chart.js';
import {
    Doughnut, Bar,
    getElementAtEvent,
    getDatasetAtEvent
} from 'react-chartjs-2';
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import _ from "lodash";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}
export default function SubContractorDashboard(props) {
    const colors = [
        { name: 'Red', value: 'rgba(200, 0, 0, 0.85)' },
        { name: 'Yellow', value: 'rgba(255,103,0, 0.85)' },
        { name: 'Green', value: 'rgba(0, 128, 0, 0.85)' }
    ]
    const failColor = "rgba(200, 0, 0, 0.85)"
    const failHoverColor = "rgba(200, 0, 0, 0.65)"
    const warningColor = "rgba(255,103,0, 0.85)"
    const warningHoverColor = "rgba(255,103,0, 0.65)"
    const passColor = "rgba(0, 128, 0, 0.85)"
    const passHoverColor = "rgba(0, 128, 0, 0.65)"

    const availableComplianceList = ['Provider Deposits', 'Carrier Disbursements', 'ACA Compliance', 'Cash in lieu', 'Contract Updates', 'Hours Management'];
    const barChartlabels = ['Provider Deposits', 'Carrier Disbursements', 'ACA Compliance', 'Cash in lieu', 'Contract Updates'];
    const initBarChartData = {
        labels: barChartlabels,
        datasets: []
    };
    const [contracts, setContracts] = useState([]);
    const [barChartData, setBarChartData] = useState(initBarChartData);
    const [beginDate, setBeginDate] = useState(dayjs().set('date', 1))
    const [endDate, setEndDate] = useState(dayjs().endOf('month'))
    const [isLoading, setIsLoading] = useState(false);
    const [showChart, setShowChart] = useState(true);
    const [complianceFilter, setComplianceFilter] = useState(barChartlabels);
    const [highLightedComplianceType, setHighLightedComplianceType] = useState('');
    const [colorFilter, setColorFilter] = useState("none");
    const [selectedContract, setSelectedContract] = useState();
    const [selectedContractList, setSelectedContractList] = useState([])
    const [currentElement, setCurrentElement] = useState();
    const [openBeginDate, setOpenBeginDate] = useState(false);
    const [openEndDate, setOpenEndDate] = useState(false);
    const [beginDateError, setBeginDateError] = useState(null);
    const [endDateError, setEndDateError] = useState(null);
    useEffect(() => {
        console.log('should fetch all contracts')
    }, []);

    const chartRef = useRef();

    const barChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        minBarLength: 0,
        legend: { position: 'bottom' },

    };
    const statusToSeverity = (status) => {
        switch (status) {
            case "pass":
                return "success";
            case "failed":
                return "error";
            default:
                return "warning";
        }
    }
    const showAction = (contractorCompliance) => {
        if (contractorCompliance.status != "pass") {
            if (
                //(props.isAximClinet === undefined || !props.isAximClinet) && 
                contractorCompliance.complianceType == "Contract Updates") {
                return <Button><Link to={`${props.path}/contracts`}>Go to contracts</Link></Button>
            }

            if (contractorCompliance.status == "failed") {
                if (contractorCompliance.complianceType == "Provider Deposits") {
                    return <Button><Link to={`${props.path}/uploads`}>Upload Provider Deposits</Link></Button>
                }
                else if (contractorCompliance.complianceType == "Carrier Disbursements") {
                    return <Button><Link to={`${props.path}/uploads`}>Upload Carrier Disbursements</Link></Button>
                }
            }
        }
        return <></>;
    }

    const handleClickChart = (event) => {
        let element = getElementAtEvent(chartRef.current, event);
        console.log('handleClickChart', element)
        setCurrentElement(element);
        if (element.length > 0) {
            let foundColor = colors.find(c => c.value == barChartData.datasets[element[0].datasetIndex].backgroundColor)
            if (foundColor) {
                setColorFilter(foundColor)
            }
            let complianceType = barChartlabels[element[0].index]
            setHighLightedComplianceType(complianceType)
            if (barChartData.datasets[element[0].datasetIndex].backgroundColor == failColor || barChartData.datasets[element[0].datasetIndex].backgroundColor == warningColor) {
                console.log('fail ', complianceType)
                setSelectedContractList(contracts.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
            }
            else {
                console.log('pass ', complianceType)
                console.log('contracts ', contracts)
                setSelectedContractList(contracts.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
                    && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
            }
        }
    }

    const subContractListColumnsArray = [
        {
            Header: "Subcontractor Name",
            accessor: (cell) => (
                <Box>
                    {cell.name}
                </Box>
            ),
        },
        {
            Header: "Compliance Status",
            accessor: "compliances",
            Cell: ({ row }) => (
                <Box>
                    <ul>
                        {(row.original?.compliances?.map((c, idx) => <li key={`row-${row.id}-${idx}`}>{c.complianceType} {(c.status == 'missing' ? ' is missing' : `${c.status} ${c.notes}`)} [{Utils.formatDate(c.beginDate)} - {Utils.formatDate(c.endDate)}]</li>))}
                    </ul>
                </Box>
            )
        }
    ];

    const [chartPassFaildata, setChartPassFaildata] = useState({
        labels: ['Fail', 'Pass'],
        datasets: [
            {
                label: '# of contractors',
                data: [0, 0],
                backgroundColor: [
                    'rgba(250, 0, 0, 1)',
                    'green',
                ],
                borderColor: [
                    'rgba(250, 0, 0, 1)',
                    'green',
                ],
                borderWidth: 1,
            },
        ],
    });


    const getContracts = (start, end) => {
        setIsLoading(true);
        console.log('getContracts')
        console.log(contractorApiUrls.getDashboard(start, end))
        apiGet(contractorApiUrls.getDashboard(start, end))
            .then((response) => {
                console.log('dashboard contracts', response.data);
                setContracts(response.data);
                const uniqueCompanyId = [...new Set(response.data.map(r => r.companyId))];
                // if (uniqueCompanyId.length > 0) {
                //     setCompany(uniqueCompanyId[0])
                // }

                console.log('fail pass')
                const failedList = response.data.filter(({ status }) => status.value < 1);
                const passList = response.data.filter(({ status }) => status.value == 1);
                const graphData = complianceFilter.map(b => failedList.filter(f => f.compliances.filter(c => c.complianceType == b && (c.status == "failed" || c.status == "missing")).length > 0).length);
                setChartPassFaildata({
                    labels: [`Fail: ${failedList.length}`, `Pass: ${passList.length}`],
                    datasets: [
                        {
                            label: '# of contracts',
                            data: [failedList.length, passList.length],
                            backgroundColor: [
                                'rgba(200, 0, 0, 1)',
                                'rgba(0, 128, 0, 1)'
                            ],
                            hoverBackgroundColor: [
                                'rgba(220, 0, 0, 1)',
                                'rgba(0, 148, 0, 1)'
                            ],
                            borderWidth: 1,
                        },
                    ],
                })


                const totalContracts = failedList.length + passList.length;
                console.log('graphData')
                const graphColors = graphData.map(x => {
                    if ((x / totalContracts) > 0.75) {
                        return 'rgba(200, 0, 0, 1)'
                    }
                    else if ((x / totalContracts) > 0.5) {
                        return 'rgba(255,103,0, 1)'
                    }
                    else {
                        return 'rgba(0, 128, 0, 1)'
                    }
                })
                const graphRed = graphData.map(x => {
                    if ((x / totalContracts) > 0.75) {
                        return x
                    }
                    return 0
                })
                console.log(graphRed, 'graph red')
                const graphYellow = graphData.map(x => {
                    const per = (x / totalContracts);
                    if (per <= 0.75) {
                        return x
                    }
                    return 0
                })
                const graphGreen = graphData.map(x => {
                    return totalContracts - x
                })
                setBarChartData({
                    labels: complianceFilter,
                    datasets: [{
                        label: 'Failed over 75%',
                        scales: {
                            y: {
                                display: false // Hide Y axis labels
                            },
                            x: {
                                display: false // Hide X axis labels
                            }
                        },
                        legend: {
                            display: true
                        },
                        backgroundColor: failColor,
                        hoverBackgroundColor: failHoverColor,
                        data: graphRed,
                        stack: 'Stack 0',
                    }, {
                        label: 'Failed less than 75%',
                        legend: {
                            display: true
                        },
                        backgroundColor: warningColor,
                        hoverBackgroundColor: warningHoverColor,
                        data: graphYellow,
                        stack: 'Stack 0',
                    }, {
                        label: 'Pass',
                        legend: {
                            display: true
                        },
                        backgroundColor: passColor,
                        hoverBackgroundColor: passHoverColor,
                        data: graphGreen,
                        stack: 'Stack 0',
                    }],
                })

                let element = currentElement
                if (element.length > 0) {
                    let complianceType = barChartlabels[element[0].index]
                    if (barChartData.datasets[element[0].datasetIndex].backgroundColor == failColor || barChartData.datasets[element[0].datasetIndex].backgroundColor == warningColor) {
                        setSelectedContractList(response.data.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length > 0)))
                    }
                    else {
                        setSelectedContractList(response.data.filter(f => (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "pass")).length > 0)
                            && (f.compliances.filter(c => c.complianceType == complianceType && (c.status == "failed" || c.status == "missing")).length == 0)))
                    }
                }
            })
            .catch(e => {
                //console.log(e);
                //setHasInitializationError(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const colorFilterUpdate = useMemo(() => {
        console.log('colorFilterUpdate')

        let status = ""
        if (colorFilter) {
            console.log('colorFilter', colorFilter)
        }
        if (colorFilter.name == "Green") {
            status = "pass"
        }
        else if (colorFilter.name == "Red") {
            status = "failed"
        }
        else if (colorFilter.name == "Yellow") {
            status = "failed"
        }

        if (status == "failed") {
            //this sets at the contract level
            setSelectedContractList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
                && (c.status == "failed" || c.status == "missing")).length > 0)))
        }
        if (status == "pass") {
            setSelectedContractList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")
                && (c.status == "pass")).length > 0)
                && (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "") && (c.status == "failed" || c.status == "missing")).length == 0)))
        }

        if (status == "") {
            setSelectedContractList(contracts.filter(f => (f.compliances.filter(c => (c.complianceType == highLightedComplianceType || highLightedComplianceType == null || highLightedComplianceType == "")))))
        }
    }, [colorFilter])

    const highLightedComplianceTypeUpdate = useMemo(() => {
        console.log('highLightedComplianceType')
        if (highLightedComplianceType == '') {
          setColorFilter("none")
        }
      }, [highLightedComplianceType])

    const complianceFilterUpdate = useMemo(() => {
        console.log('complianceFilterUpdate')
        if (colorFilter) {
            console.log('colorFilter', colorFilter)
        }

        if (complianceFilter) {
            console.log('complianceFilter', complianceFilter)
        }
        getContracts(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
    }, [complianceFilter])

    const isNotFirstDay = (date) => {
        return date.date() != 1;
    }

    const isNotLastDay = (date) => {
        return date.date() != date.endOf('month').date();
    }

    const handleBeginDateChange = _.debounce((val) => {
        console.log(' handleBeginDateChange', val)
        setBeginDate(val)
        if (endDate > val) {
            setBeginDateError(null)
            setEndDateError(null)
            getContracts(val?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
        }
        else {
            setBeginDateError({ message: 'Begin date must be less than end date' })
            setEndDateError({ message: 'End date must be greater than begin date' })
        }
    }, 1000);

    const handleEndDateChange = _.debounce((val) => {
        console.log(' handleEndDateChange', val)
        setEndDate(val)
        if (beginDate < val) {
            setBeginDateError(null)
            setEndDateError(null)
            getContracts(beginDate?.format('YYYY-MM-DD'), val?.format('YYYY-MM-DD'))
        }
        else {
            setBeginDateError({ message: 'Begin date must be less than end date' })
            setEndDateError({ message: 'End date must be greater than begin date' })
        }
    }, 1000);


    useEffect(() => {
        getContracts(beginDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))
    }, []);

    const translateColor = (colorFilter) => {
        if (colorFilter?.name) {
            switch (colorFilter?.name) {
                case "Green":
                    return "success";
                case "Yellow":
                    return "warning";
                case "Red":
                    return "error";
                default:
                    return "";
            }
        }
        return "";
    }
    const ComplianceFilterBox = ({ compliances, complianceFilter, setComplianceFilter, highLightedComplianceType, setHighLightedComplianceType, colorFilter }) => {
        return (
            <FormControl sx={{ maxWidth: 300 }}>
                <InputLabel id="compliance-multiple-checkbox-label">
                    {highLightedComplianceType == '' ? <span>Compliance Filter</span> : <Chip label={highLightedComplianceType}
                        color={translateColor(colorFilter)}
                        onDelete={() => { setHighLightedComplianceType('') }}
                    />}
                </InputLabel>
                <Select
                    variant="standard"
                    labelId="compliance-multiple-checkbox-label"
                    id="compliance-multiple-checkbox"
                    multiple
                    value={complianceFilter}
                    onChange={(event) => {
                        const {
                            target: { value },
                        } = event;
                        setComplianceFilter(
                            // On autofill we get a stringified value.
                            typeof value === 'string' ? value.split(',') : value,
                        )
                    }}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(complianceFilter) => complianceFilter.join(', ')}
                    MenuProps={MenuProps}
                >
                    {compliances.map((value, index) => <MenuItem key={`compliance-menu-${index}`} value={value}>
                        <Checkbox checked={(complianceFilter.indexOf(value) > -1)} />
                        <ListItemText primary={value} />
                    </MenuItem>)}
                </Select>
            </FormControl>
        )
    }
    const ColorFilterBox = ({ colors, colorFilter, setColorFilter }) => {
        return (
            <>

                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        Filter By Color:
                    </Grid>
                    <Grid item xs={9}>
                        <Button
                            key={`filter-color-none`}
                            className="me-1"
                            variant={colorFilter.name === "none" ? "contained" : "outlined"}
                            onClick={(e) => setColorFilter("none")}
                            color="Grey"
                        >
                            None
                        </Button>

                        {colors.map((value) => {
                            return (
                                <Button
                                    key={`filter-color-${value.name}`}
                                    className="me-1"
                                    variant={colorFilter.name === value.name ? "contained" : "outlined"}
                                    onClick={(e) => setColorFilter(value)}
                                    color={value.name}
                                >
                                    {value.name}
                                </Button>
                            )
                        })
                        }
                    </Grid>
                </Grid>
            </>
        )
    }

    const SearchAndFilterBox = ({ companies, companyFilter, setCompanyFilter, colors, colorFilter, setColorFilter, compliances, complianceFilter, setComplianceFilter, highLightedComplianceType, setHighLightedComplianceType }) => {
        return (
            <Box
                component="form"
                noValidate
                autoComplete="off"
            >
                <Grid container spacing={2}>
                    {/* <Grid item xs={3}><SortBox sortValue={sortValue} setSortValue={setSortValue} /></Grid> */}
                    <Grid item md={6} sm={12} ><ComplianceFilterBox compliances={compliances} complianceFilter={complianceFilter} setComplianceFilter={setComplianceFilter}
                        highLightedComplianceType={highLightedComplianceType}
                        setHighLightedComplianceType={setHighLightedComplianceType}
                        colorFilter={colorFilter} /></Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}><ColorFilterBox colors={colors} colorFilter={colorFilter} setColorFilter={setColorFilter} /></Grid>
                    {/* <Grid item xs={3}><RegionFilterBox /></Grid> */}
                </Grid>
            </Box>
        );
    }
    return (((contracts && contracts.length) > 0 ?
        <Box sx={{ marginTop: '20px' }}>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={9}>
                    <Grid container spacing={4} >
                        <p>&nbsp;</p>
                    </Grid>
                    <Grid container spacing={4} >
                        <Grid item md={3} sm={12} >

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    open={openBeginDate}
                                    onClose={() => setOpenBeginDate(false)}
                                    id="beginDate"
                                    name="beginDate"
                                    minDate={dayjs('01/01/1900')}
                                    value={beginDate}
                                    onAccept={(newValue) => handleBeginDateChange(newValue)}
                                    shouldDisableDate={isNotFirstDay}
                                    label="Compliance Begin Date"
                                    slotProps={{
                                        textField: {
                                            readOnly: true,
                                            onClick: () => setOpenBeginDate(true),
                                            error: !!beginDateError,
                                            helperText: beginDateError?.message,
                                        },
                                        layout: {
                                            sx: {
                                                '.MuiPickersDay-root:not(.Mui-disabled):not(.Mui-selected)': {
                                                    color: '#000',
                                                    borderRadius: 2,
                                                    borderWidth: 1,
                                                    borderColor: '#2196f3',
                                                    border: '1px solid',
                                                    backgroundColor: '#bbdefb',
                                                }
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item md={3} sm={12} >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    open={openEndDate}
                                    onClose={() => setOpenEndDate(false)}
                                    id="endDate"
                                    name="endDate"
                                    minDate={beginDate}
                                    value={endDate}
                                    onAccept={(newValue) => handleEndDateChange(newValue)}
                                    shouldDisableDate={isNotLastDay}
                                    label="Compliance End Date"
                                    slotProps={{
                                        textField: {
                                            readOnly: true,
                                            onClick: () => setOpenEndDate(true),
                                            error: !!endDateError,
                                            helperText: endDateError?.message,
                                        },
                                        layout: {
                                            sx: {
                                                '.MuiPickersDay-root:not(.Mui-disabled):not(.Mui-selected)': {
                                                    color: '#000',
                                                    borderRadius: 2,
                                                    borderWidth: 1,
                                                    borderColor: '#2196f3',
                                                    border: '1px solid',
                                                    backgroundColor: '#bbdefb',
                                                }
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item md={6} sm={12} >

                            <SearchAndFilterBox
                                colors={colors}
                                colorFilter={colorFilter}
                                setColorFilter={setColorFilter}
                                compliances={availableComplianceList}
                                complianceFilter={complianceFilter}
                                setComplianceFilter={setComplianceFilter}
                                highLightedComplianceType={highLightedComplianceType}
                                setHighLightedComplianceType={setHighLightedComplianceType}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} >
                        <p>&nbsp;</p>
                    </Grid>
                    {showChart ?
                        <Grid container spacing={4} sx={{ height: '360px' }}>
                            <Grid item md={6} sm={12} sx={{ height: '380px' }}>
                                <Paper sx={{ height: '350px' }}>
                                    <Doughnut
                                        options={{
                                            padding: "0px",
                                            maintainAspectRatio: false,
                                            height: "300",
                                            spacing: 2,
                                            cutout: "70%",
                                        }} data={chartPassFaildata} />
                                </Paper>
                            </Grid>
                            <Grid item md={6} sm={12} sx={{ height: '380px' }}>
                                <Paper sx={{ height: '350px' }}>
                                    <Bar options={barChartOptions} data={barChartData} ref={chartRef} onClick={handleClickChart} />
                                </Paper>
                            </Grid>
                        </Grid> : <></>}
                    <Grid container sx={{ marginTop: '50px' }}>
                        <Grid item md={12} sm={12} >
                            <TableAllData
                                className={TableStyle.TimeSheetsWrapper}
                                columns={subContractListColumnsArray}
                                data={selectedContractList}
                                headerContents={<span>Total Records: {selectedContractList.length} </span>}>
                            </TableAllData>
                        </Grid>
                    </Grid>
                    <Stack sx={{ width: '50%', padding: '10px' }} spacing={2}>
                        {
                            selectedContract?.compliances.map((c, idx) => {
                                if ((props.isAximClinet) && c.complianceType == "Contract Updates") {
                                    return <></>
                                }

                                return <Alert key={idx} severity={statusToSeverity(c.status)}>
                                    <p>{c.complianceType}</p>
                                    <p>{c.notes}</p>
                                    <p>
                                        {showAction(c)}
                                    </p>
                                </Alert>
                            })
                        }
                    </Stack>
                </Grid>
            </Grid>
        </Box>
        : <></>
    )
    );
}

